/** Minimums aligned with Get Started essentials + optional polish. */
export const PROFILE_COMPLETION_MIN_BIO = 40;
export const PROFILE_COMPLETION_MIN_PHOTOS = 2;
export const PROFILE_COMPLETION_MIN_INTERESTS = 3;

/**
 * Weighted checklist for a "fully complete" profile (Settings %).
 * Essentials + optional polish each count equally.
 */
export function getProfileCompletion({
  bio = "",
  gender = "",
  birthDate = "",
  photoCount = 0,
  occupation = "",
  education = "",
  drinking = "",
  smoking = "",
  workout = "",
  religion = "",
  interestCount = 0,
} = {}) {
  const checks = [
    Boolean(String(bio).trim().length >= PROFILE_COMPLETION_MIN_BIO),
    Boolean(String(gender).trim()),
    Boolean(String(birthDate).trim()),
    Number(photoCount) >= PROFILE_COMPLETION_MIN_PHOTOS,
    Boolean(String(occupation).trim()),
    Boolean(String(education).trim()),
    Boolean(String(drinking).trim()),
    Boolean(String(smoking).trim()),
    Boolean(String(workout).trim()),
    Boolean(String(religion).trim()),
    Number(interestCount) >= PROFILE_COMPLETION_MIN_INTERESTS,
  ];

  const filled = checks.filter(Boolean).length;
  const total = checks.length;
  const percent = Math.round((filled / total) * 100);

  return {
    filled,
    total,
    percent,
    isComplete: filled === total,
  };
}
